import { useTranslation } from 'react-i18next';
import { AppLanguage } from '~/common/enums/enums';
import { AppLocalizationKey } from '~/common/types/types';

type UseAppTranslation = () => {
  currentLanguage: AppLanguage;
  handleTranslate: (key: AppLocalizationKey) => string;
  handleLanguageChange: (language: AppLanguage) => void;
};

const useAppTranslation: UseAppTranslation = () => {
  const { t, i18n } = useTranslation();
  const { changeLanguage, resolvedLanguage } = i18n;

  return {
    handleTranslate: t,
    handleLanguageChange: changeLanguage,
    currentLanguage: resolvedLanguage as AppLanguage,
  };
};

export { useAppTranslation };
